import React from 'react';

import { AccountControlsDesktop } from './AccountControlsDesktop';
import { AccountControlsMobile } from './AccountControlsMobile';
import { useIsMobile } from 'hooks/useIsMobile';

type Props = { redirectOnSignedOutTo?: string };

export const AccountControls = (props: Props) => {
  const { redirectOnSignedOutTo } = props;
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <AccountControlsMobile redirectOnSignedOutTo={redirectOnSignedOutTo} />
    );
  }

  return (
    <AccountControlsDesktop redirectOnSignedOutTo={redirectOnSignedOutTo} />
  );
};
